import { useDeleteTokenById } from "lib/api-tokens";
import {
    Badge,
    Card,
    CardHeader,
    CardFooter,
    // DropdownMenu,
    // DropdownItem,
    // UncontrolledDropdown,
    // DropdownToggle,
    Media,
    Pagination,
    PaginationItem,
    PaginationLink,
    Table,
    Row,
    Button,
} from "reactstrap";

const TokensTable = ({ tokensData, onAddToken, isLoading }) => {
    return (
        <Row>
            <div className="col">
                <Card className="shadow">
                    <CardHeader className="border-0">
                        <Row className="align-items-center">
                            <div className="col">
                                <h3 className="mb-0">Tokens Management</h3>
                            </div>
                            <div className="col text-right">
                                <Button
                                    color="primary"
                                    onClick={onAddToken}
                                    size="sm"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Adding..." : "Add New Token"}
                                </Button>
                            </div>
                        </Row>
                    </CardHeader>

                    <Table
                        className="align-items-center table-flush"
                        responsive
                    >
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Token</th>
                                <th scope="col">Symbol</th>
                                <th scope="col">Network</th>
                                <th scope="col">Price</th>
                                <th scope="col">Type</th>
                                <th scope="col">Status</th>
                                <th scope="col">Created</th>
                                <th scope="col" />
                            </tr>
                        </thead>
                        <tbody>
                            {tokensData.length > 0 ? (
                                tokensData.map((token) => (
                                    <TokenRow key={token._id} token={token} />
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="8"
                                        className="text-center py-4"
                                    >
                                        <p className="text-muted mb-0">
                                            No tokens found
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <CardFooter className="py-4">
                        {tokensData.length > 10 && (
                            <nav aria-label="...">
                                <Pagination
                                    className="pagination justify-content-end mb-0"
                                    listClassName="justify-content-end mb-0"
                                >
                                    <PaginationItem className="disabled">
                                        <PaginationLink
                                            href="#pablo"
                                            onClick={(e) => e.preventDefault()}
                                            tabIndex="-1"
                                        >
                                            <i className="fas fa-angle-left" />
                                            <span className="sr-only">
                                                Previous
                                            </span>
                                        </PaginationLink>
                                    </PaginationItem>
                                    {tokensData.length > 10 &&
                                        tokensData.length <= 20 && (
                                            <>
                                                <PaginationItem className="active">
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                    >
                                                        1
                                                    </PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem>
                                                    <PaginationLink
                                                        href="#pablo"
                                                        onClick={(e) =>
                                                            e.preventDefault()
                                                        }
                                                    >
                                                        2{" "}
                                                        <span className="sr-only">
                                                            (current)
                                                        </span>
                                                    </PaginationLink>
                                                </PaginationItem>
                                            </>
                                        )}

                                    {tokensData.length > 20 &&
                                        tokensData.length <= 30 && (
                                            <PaginationItem>
                                                <PaginationLink
                                                    href="#pablo"
                                                    onClick={(e) =>
                                                        e.preventDefault()
                                                    }
                                                >
                                                    3
                                                </PaginationLink>
                                            </PaginationItem>
                                        )}
                                    <PaginationItem>
                                        <PaginationLink
                                            href="#pablo"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="fas fa-angle-right" />
                                            <span className="sr-only">
                                                Next
                                            </span>
                                        </PaginationLink>
                                    </PaginationItem>
                                </Pagination>
                            </nav>
                        )}
                    </CardFooter>
                </Card>
            </div>
        </Row>
    );
};

const TokenRow = ({ token }) => {
    const deleteTokenMutation = useDeleteTokenById(token._id);

    const handleDelete = () => {
        if (window.confirm("Are you sure you want to delete this token?")) {
            deleteTokenMutation.mutate();
        }
    };

    return (
        <tr>
            <th scope="row">
                <Media className="align-items-center">
                    <a
                        className="avatar rounded-circle mr-3"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                    >
                        <img
                            className="rounded-circle avatar bg-white"
                            alt={token.name}
                            src={token.logoUrl}
                            onError={(e) => {
                                e.target.src = require("../../assets/img/theme/bootstrap.jpg");
                            }}
                        />
                    </a>
                    <Media>
                        <span className="mb-0 text-sm font-weight-bold">
                            {token.name}
                        </span>
                        <br />
                        <small className="text-muted">
                            {token.coinGeckoId}
                        </small>
                    </Media>
                </Media>
            </th>
            <td>
                <span className="font-weight-bold">{token.symbol}</span>
                <br />
                <small className="text-muted">{token.symbolShort}</small>
            </td>
            <td>
                <Badge color={token.isMainnet ? "success" : "warning"}>
                    {token.networkId}
                </Badge>
            </td>
            <td>
                <span className="font-weight-bold">
                    ${(token.price || 0).toLocaleString()}
                </span>
            </td>
            <td>
                <Badge color={token.isToken ? "info" : "primary"}>
                    {token.isToken ? "Token" : "Coin"}
                </Badge>
            </td>
            <td>
                <Badge color={!token.isDeleted ? "success" : "danger"}>
                    {!token.isDeleted ? "Active" : "Deleted"}
                </Badge>
            </td>
            <td>
                {token.createdAt
                    ? new Date(token.createdAt).toLocaleDateString()
                    : "N/A"}
            </td>
            <td className="">
                <Button
                    color="danger"
                    onClick={handleDelete}
                    disabled={deleteTokenMutation.isLoading}
                >
                    {deleteTokenMutation.isLoading ? "Deleting..." : "Delete"}
                </Button>
            </td>
        </tr>
    );
};

export default TokensTable;